/**
 * @param {string} id
 * @param {Document|Element} root
 * @returns {HTMLElement|null}
 */
export function getById(id, root = document) {
  if ('getElementById' in root) {
    return root.getElementById(id);
  }

  return root.querySelector(`#${id}`);
}

/**
 * @param {Document|Element} root
 * @returns {HTMLBodyElement|null}
 */
export function getBody(root = document) {
  if ('body' in root) {
    return root.body;
  }

  return document.body;
}
